import { NgModule } from 'ng-metadata/core';
import { AnnouncementComponent } from './announcement.component';
import { AnnouncementService } from './announcement.service';
import './annoucement.scss';

angular.module('mwAppComponents.announcement.services', [])
    .service('mwAnnouncementService', AnnouncementService);


/**
 * @ngdoc module
 * @name mw.components.announcement
 * @description
 *
 * Announcement
 */
@NgModule({
    declarations: [ AnnouncementComponent ],
    providers: [ {provide: 'mwAnnouncementService', useClass: AnnouncementService} ],
    imports: [ 'mwAppComponents.announcement.services' ]
})
export class AnnouncementModule {}



// WEBPACK FOOTER //
// ./src/lib/components/announcement/announcement.module.ts